function TermsAndConditionsModal() {


    return (
        <>
            <div
                className="modal fade"
                id="termsModal"
                tabIndex="-1"
                aria-labelledby="termsModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="termsModalLabel">Terms and Conditions</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                            <p><strong>Effective Date:</strong> [Insert Date]</p>
                            <p>Welcome to the <strong>P M Shri Kendriya Vidyalaya Ordnance Factory Jawahar Nagar Bhandara Alumni Portal</strong>. By registering and using this platform, you agree to the following terms and conditions:</p>

                            <h6>1. Acceptance of Terms</h6>
                            <p>By accessing or using this platform, you agree to comply with these Terms and Conditions, our Privacy Policy, and any other guidelines set forth by the Association.</p>

                            <h6>2. Eligibility</h6>
                            <p>Only former students or staff of P M Shri Kendriya Vidyalaya Ordnance Factory Jawahar Nagar Bhandara may register. We may verify your status before approving your membership.</p>

                            <h6>3. Account Responsibilities</h6>
                            <ul>
                                <li>Maintain the confidentiality of your login credentials.</li>
                                <li>Ensure all registration information is accurate and current.</li>
                                <li>Notify us immediately of unauthorized use of your account.</li>
                            </ul>

                            <h6>4. Code of Conduct</h6>
                            <p>As a member, you agree to:</p>
                            <ul>
                                <li>Engage respectfully with others on the platform.</li>
                                <li>Not post inappropriate, harmful, or illegal content.</li>
                                <li>Use the platform only for alumni-related purposes.</li>
                            </ul>

                            <h6>5. Membership Fees</h6>
                            <p>Some membership plans may include fees (e.g., annual, lifetime, or security deposits). All fees are clearly outlined prior to registration and are non-refundable unless stated otherwise.</p>

                            <h6>6. Events and Donations</h6>
                            <p>This platform may promote alumni events and donation opportunities. Participation is voluntary and transparent.</p>

                            <h6>7. Privacy</h6>
                            <p>Your personal data is protected and used only for alumni communication and engagement. We do not sell or share your data without consent. Please review our full Privacy Policy for more details.</p>

                            <h6>8. Account Termination</h6>
                            <p>We reserve the right to suspend or remove any user who violates these terms or behaves inappropriately on the platform.</p>

                            <h6>9. Changes to Terms</h6>
                            <p>We may update these Terms from time to time. Continued use of the platform after changes constitutes your acceptance of the revised Terms.</p>

                            <h6>10. Contact Us</h6>
                            <p>If you have any questions or concerns, please contact:</p>
                            <ul>
                                <li>Email: alumni@[schooldomain].com</li>
                                <li>Phone: +91-XXXXXXXXXX</li>
                            </ul>

                            <p className="mt-4"><strong>By checking the box, you agree to these Terms and Conditions.</strong></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default TermsAndConditionsModal;
